import { useSessionStorage } from "@uidotdev/usehooks";
import { GetRecommendations } from "../components";
import clearPlanDoctorsFromSessionStorage from "../functions/clearDoctors.function";
import ScrollToTopOnRouteChange from "../shared/ScrollToTop.function";
import { useUpdateBreadcrumbs } from "../shared/updateBreadcrumbs.hook";
import { useEffect } from "react";

const HomePage = () => {
  useUpdateBreadcrumbs("Get Recommendations");
  clearPlanDoctorsFromSessionStorage();
  const [, setComparePlans] = useSessionStorage("dataArray", []);

  useEffect(() => {
    setComparePlans([]);
  }, []);

  return (
    <div className="grid-container">
      <div className="grid-x">
        <div className="cell small-12">
          <ScrollToTopOnRouteChange />
          <GetRecommendations />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
